var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 512 512"
      }
    },
    [
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M45.5,20.5L18.3,38.1l1.8,2.8l5-3.3v26h-3.7V67h50.7v-3.4h-4.4v-26l5,3.3l1.8-2.8L47.4,20.5C46.8,20.1,46.1,20.1,45.5,20.5   z M57.2,42.9c0,5.9-10.7,17-10.7,17s-10.7-11.1-10.7-17c0-5.9,4.8-10.7,10.7-10.7C52.4,32.2,57.2,37,57.2,42.9z",
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-miterlimit": "10",
            "stroke-width": "20"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }